import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import { observer, inject } from 'mobx-react';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import { PageWrapper } from 'components/PageWrapper';
import Form from '../components/CategoryForm';
import { CLINICAL_NOTE_WRITING_CATEGORY_CONSTRAINS } from 'constants/adminPupups';

const CATEGORY_API = '/api/v1/note_categories/';
const TOPICS_API = '/api/v1/note_topics?category_id=';

@inject('clinicalNoteWritingCategoriesStore')
@inject('clinicalNoteWritingTopicsStore')
@inject('alertStore')
@observer
class Edit extends Component {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const {
      match,
      clinicalNoteWritingCategoriesStore: {
        setCategory,
      },
      clinicalNoteWritingTopicsStore: {
        setTopics,
      },
    } = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${CATEGORY_API}${id}`).then(data => {
        const category = data.body.data.note_category;

        setCategory(category);
        new HttpClient().get(`${TOPICS_API}${id}`).then(data => {
        const topics = data.body.data.note_topic;

        setTopics(topics);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  componentWillUnmount() {
    const {
      clinicalNoteWritingCategoriesStore: {initNewCategory},
      clinicalNoteWritingTopicsStore: {setTopics}
    } = this.props;

    initNewCategory();
    setTopics([]);
  }

  validationProcess = resource => {
    let errors = validate(resource, CLINICAL_NOTE_WRITING_CATEGORY_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {clinicalNoteWritingCategoriesStore, match} = this.props;
    const id = match.params.id;
    const category = _.assign({}, clinicalNoteWritingCategoriesStore.category);
    const errors = this.validationProcess(theme);

    clinicalNoteWritingCategoriesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', category.title);

    new HttpClient().multipart(`${CATEGORY_API}${id}`, formData, 'PUT').then(data => {
      clinicalNoteWritingCategoriesStore.setCategory(data.body.data.note_category);
      this.props.alertStore.success('Category successfully edited');
      // this.props.history.push('/mcq-themes');
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  deleteCategory = () => {
    const { alertStore, history, match } = this.props;
    const id = match.params.id;

    new HttpClient().delete(`${CATEGORY_API}${id}`)
    .then(() => {
      alertStore.success('You successfully delete category');
      history.push('/clinical-notes-writing');
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  render() {
    const { isConfirmModalOpened } = this.state;
    const {
      clinicalNoteWritingCategoriesStore: { category },
      clinicalNoteWritingTopicsStore: { topics },
    } = this.props;

    return (
      <PageWrapper>
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this category?'
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.deleteCategory}
            >
              Yes
            </button>
          </div>
        </Dialog>
        <button onClick={this.handleOpenConfirmModal} className='delete-btn'>delete category</button>
        <Form submit={this.submit} />

        <Link to={`/clinical-notes-writing/${category.id}/add-topic`}>+ Add New Topic</Link>
        <div className="row">
          <div className="container">
            <div className="mcq-questions-list">
              {topics.length > 0 ? topics.map((topic) => (
                <Link
                  to={`/clinical-notes-writing/${topic.id}/edit-topic/${topic.id}`}
                  key={`cnw_topic_${topic.id}`}
                >
                  {topic.title}
                </Link>
              )) : (
                <div className="empty-list-container">
                  <span className="self-center">There is no topics</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/Edit.js